export const UNSURE_CLASS = 'Unsure';
